import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Controller } from 'react-hook-form';
import { FormControl, Grid } from '@material-ui/core';
import Button from '../../Common/Form/Button';
import FormAlert from '../../Common/Form/FormAlert';

import NumberInput from '../../Common/Form/NumberInput';
import { SEGMENT_EXPECTATIONS } from '../../../helpers/constants';

const propTypes = {
  eventMeta: PropTypes.object,
  initialValues: PropTypes.object,
  formMethods: PropTypes.shape({
    control: PropTypes.object,
    errors: PropTypes.object,
    trigger: PropTypes.func,
    watch: PropTypes.func,
    isValid: PropTypes.func,
    loading: PropTypes.boolean,
  }).isRequired,
  isSuccess: PropTypes.boolean,
  isDirty: PropTypes.boolean,
};
const defaultProps = {
  eventMeta: undefined,
  initialValues: {},
  isSuccess: false,
  isDirty: false,
};

function ExpectationsFields({ eventMeta, formMethods, initialValues, isSuccess, isDirty }) {
  const { control, errors, trigger, watch, isValid, loading } = formMethods;

  const [isModified, setIsModified] = useState(false);

  let segmentExpecation = [];
  if (eventMeta.category === 'Sports') {
    segmentExpecation = Object.entries(SEGMENT_EXPECTATIONS.sport_event);
  } else {
    segmentExpecation = Object.entries(SEGMENT_EXPECTATIONS.non_sport_event);
  }

  // Reset the form values after successful submission.
  useEffect(() => {
    const hasDifferences = Object.keys(initialValues).some(key => watch(key) !== initialValues[key]);
    setIsModified(hasDifferences);
    if (Object.keys(initialValues).length === 0) {
      setIsModified(true);
    }
    trigger();
  }, [
    watch('lse_dte_60'),
    watch('lse_dte_30'),
    watch('lse_dte_15'),
    watch('lse_dte_7'),
    watch('lse_dte_4'),
    watch('lse_sellout_dte_target'),
    watch('lse_sellout_dte'),
    initialValues,
  ]);

  return (
    <Grid container style={{ marginBottom: '-10px' }}>
      {segmentExpecation.map(([key, labelValue]) => (
        <Grid item key={key}>
          <FormControl>
            <Controller
              name={key}
              control={control}
              render={({ field: { value, onChange, ...rest } }) => (
                <NumberInput
                  expectationsForm
                  allowsZero={labelValue === 'Sellout DTE'}
                  disabled={false}
                  labelValue={labelValue}
                  keyValue={key}
                  error={Object.keys(errors).includes(key)}
                  errors={errors}
                  label={labelValue}
                  min={0}
                  value={value === null ? '' : value}
                  onChange={strValue => {
                    const newValue = strValue === '' ? null : Number(strValue);
                    onChange(newValue);
                  }}
                  {...rest}
                />
              )}
            />
          </FormControl>
        </Grid>
      ))}
      <Grid item>
        <div style={{ marginTop: '16px' }}>
          <Button disabled={!isValid || loading || !isModified} type="submit">
            Save Line Segment
          </Button>
        </div>
      </Grid>
      <Grid item>
        <div style={{ marginTop: '24px', marginLeft: '5px' }}>
          {isSuccess && !isDirty ? <FormAlert variant="success">Submitted!</FormAlert> : null}
        </div>
      </Grid>
    </Grid>
  );
}

ExpectationsFields.propTypes = propTypes;
ExpectationsFields.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    eventMeta: state.pricing.eventMeta,
  };
}

export default connect(mapStateToProps)(ExpectationsFields);
